import { render, staticRenderFns } from "./LazyLoadingTables.vue?vue&type=template&id=11d0b071&"
import script from "./LazyLoadingTables.vue?vue&type=script&lang=js&"
export * from "./LazyLoadingTables.vue?vue&type=script&lang=js&"
import style0 from "./LazyLoadingTables.vue?vue&type=style&index=0&id=11d0b071&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports